// assets/cart.ui.js
window.CartMethodsUI = {
    formatCurrency(number) {
        let res = number.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        return res;
    },

    updateDiscountFromCart() {
        let discountsFromStorage = JSON.parse(localStorage.getItem('cart_level_discount_applications'));
        console.log(discountsFromStorage);

        if(discountsFromStorage) {
            this.discountFromCart = discountsFromStorage;
        }
    },

    discount() {
        setTimeout(this.discountUpdate, 2000);
    },

    discountUpdate() {
        this.updateCartInit();
        localStorage.setItem('cart_level_discount_applications', JSON.stringify(cart.cart_level_discount_applications));
        this.updateDiscountFromCart();
        this.cartItems = this.storageCart.items;
        this.sortCartItems();
    },

    downloadImage(url, filename) {
        const img = new Image();
        img.crossOrigin = 'anonymous';

        img.onload = function() {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            const link = document.createElement('a');
            link.href = canvas.toDataURL('image/png');
            link.download = filename;
            link.click();
        };

        img.onerror = function() {
            window.open(url, '_blank');
        };

        img.src = url;
    },

    validateMinQty(index) {
        let groupId = this.cartItems[index].properties._groupID;
        let totalQty = this.getTotalQtyByGroupId(groupId, this.cartItems[index].id) + this.cartItems[index].quantity;

        if (Object.hasOwn(this.minProductQty, groupId)) {
            if (totalQty < this.minProductQty[groupId].minQty) {
                this.minProductQty[groupId].errrorMessage = true;
            } else {
                this.minProductQty[groupId].errrorMessage = false;
            }

            this.setTotalQtyToLocalStorage(groupId);
            localStorage.setItem('minQty', JSON.stringify(this.minProductQty));
            this.disableUpdateCartByMinQty();
        }
    },

    setTotalQtyToLocalStorage(groupId) {
        if (Object.hasOwn(this.totalQtyByGroupID, groupId)){
            this.minProductQty[groupId].totalQty = this.totalQtyByGroupID[groupId].qty;
        }
    },

    disableUpdateCartByMinQty() {
        let disable = false;

        for (var groupId in this.minProductQty) {
            if (this.minProductQty[groupId].errrorMessage === true && this.productIds.includes(groupId)) {
                disable = true;
            }
        }

        this.disableUpdateCart = disable;
    },
};